import "./Services.css";
import Button from "../button/Button";
import { Link, useNavigate } from "react-router-dom";
const Services = () => {

  return (
    <div id="service-progressive" className="progressive-wrapper">
       <div className="Container-main">
        <div className="serviceContent">
          
           <h2>Start Your CRM Journey!!</h2>
          <p>
            You’ve found them. With deep industry expertise and a passion for
            immersive tech, we offer the <strong>best Custom CRM development services</strong> designed
            to elevate your brand experience through custom-built solutions.
          </p>
          <div><Link to='/contact_us' className="link"><Button  arrowColor="purple" text="Let's Talk"/></Link></div>
        </div>
     </div>
    </div>
  );
};

export default Services;
